import React from 'react';

const Wallet = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
      <rect x="0.75" y="4.93359" width="24.5" height="16.5" rx="2.25" stroke="black" strokeWidth="1.5" />
      <rect y="9.18359" width="26" height="4" fill="black" />
      <rect x="4" y="16.1836" width="7" height="2" rx="1" fill="black" />
    </svg>
  );
};

export { Wallet };
